export const firebaseConfig = {
    apiKey: "AIzaSyC_QHT8pyunYGWDx7jqt_Lob-o2KLNDkAM",
    authDomain: "in-equity.firebaseapp.com",
    projectId: "in-equity",
    storageBucket: "in-equity.appspot.com",
    messagingSenderId: "587650698350",
    appId: "1:587650698350:web:7a9792b6509eb266fa6a7f",
    measurementId: "G-PK5M3FP7K9",
    vapidKey: "BFBrsnsXNSmWcRQHiE5156-YDAmxnN6xAM501sRA3OJDVGS3alBxdSEVBWo0ggtHTgJVoFMbTmOB6AktJ0VHPEU"
};
